/**
 * See:
 * https://masonry.desandro.com/options
 * https://masonry.desandro.com/layout#imagesloaded
 */
document.addEventListener('DOMContentLoaded', function() {
  if (document.querySelector('.js-masonry-container')) {
    const grid = document.querySelector('.js-masonry-container');
    const msnry = new Masonry(grid, {
      itemSelector: '.js-masonry-item',
      gutter: 24,
      percentPosition: true,
      horizontalOrder: false,
      transitionDuration: 0 // Disable animation
    });

    // Use imagesLoaded for better reliability
    imagesLoaded(grid).on('progress', function() {
      msnry.layout();
    });

    // Mobile-first responsive gutters
    function handleResize() {
      msnry.options.gutter = window.innerWidth <= 768 ? 16 : 24;
      msnry.layout();

      // Force reflow for mobile browsers
      grid.style.display = 'none';
      //grid.offsetHeight; // Trigger reflow
      grid.style.display = '';
      msnry.layout();
    }

    // Debounced resize handler
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(handleResize, 100);
    });

    // Initial layout after all assets
    window.addEventListener('load', function() {
      msnry.layout();
      handleResize(); // Initial gutter setup
    });
  }
});
